import { render, staticRenderFns } from "./UpdateEntity.vue?vue&type=template&id=716d1710&scoped=true"
import script from "./UpdateEntity.vue?vue&type=script&lang=js"
export * from "./UpdateEntity.vue?vue&type=script&lang=js"
import style0 from "./UpdateEntity.vue?vue&type=style&index=0&id=716d1710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716d1710",
  null
  
)

export default component.exports